<template>
  <div class="attr-row" :class="{ 'attr-row--with-image': showImage }">
    <div class="attr-row__main">
      <label
          v-if="showFilterable"
          class="attr-row__check"
          :title="'فیلتر'">
        <input v-model="item.filterable" type="checkbox">
      </label>

      <div class="attr-row__input">
        <date-picker
            v-if="feature.type==='date'"
            clearable
            auto-submit
            v-model="item.value"
            placeholder="انتخاب تاریخ"
            format="YYYY-MM-DD"
            display-format="jYYYY/jM/jD"/>

        <template v-else-if="feature.type=='formula'">
          <input class="form-control" type="text" v-model="item.value" dir="rtl">
          <feature-search class="attr-row__formula-search" @selectedFeature="addVariable"/>
        </template>

        <input
            v-else
            dir="rtl"
            v-model="item.value"
            type="text"
            class="form-control text-right"
            placeholder="مقدار">
      </div>

      <button class="attr-row__close" @click="removeFeatureAttribute()" type="button" title="حذف">
        <b-icon icon="x"></b-icon>
      </button>
    </div>

    <div class="attr-row__media" v-if="showImage">
      <input
          :id="imageInputId"
          type="file"
          accept="image/*"
          class="d-none"
          @change="onFileChange">

      <div
          class="attr-row__image-wrap"
          role="button"
          tabindex="0"
          title="کلیک برای انتخاب عکس"
          @click="openImagePicker"
          @keyup.enter="openImagePicker">
        <img
            v-if="hasImage"
            alt=""
            class="attr-row__image"
            :src="item.featureImagePreview"/>
        <template v-else>
          <b-icon icon="image" class="attr-row__image-icon"/>
          <span class="attr-row__image-text">انتخاب عکس</span>
        </template>

        <button
            v-if="hasImage"
            type="button"
            class="attr-row__image-remove"
            title="حذف عکس"
            @click.stop="removeAttributeImage">
          <b-icon icon="trash"/>
        </button>
      </div>
    </div>
  </div>
</template>


<script>
import {unFilteredFeatureTypes} from '@moeinmdn/mixitweb-front-modules/src/plugin/Modules/Feature'
import {checkValueIsNumber} from "@moeinmdn/mixitweb-front-modules/src/plugin/Modules/Product";
import FeatureSearch from "@/plugin/components/dashboard/product/productFeatureComponents/FeatureSearch.vue";
import VuePersianDatetimePicker from "vue-persian-datetime-picker";


export default {
  name: "FeatureAttribute",
  components: {datePicker: VuePersianDatetimePicker, FeatureSearch},
  data() {
    return {
      unFilteredFeatureTypes,
    }
  },
  props: {
    item: {},
    feature: {},
    featureIndex: {},
  },
  computed: {
    showFilterable() {
      return this.unFilteredFeatureTypes.indexOf(this.feature.type) === -1
    },
    showImage() {
      return this.unFilteredFeatureTypes.indexOf(this.feature.type) === -1
    },
    hasImage() {
      return !!(this.item.featureImagePreview)
    },
    imageInputId() {
      return `feature-attr-image-${this.featureIndex}-${this.item.id || 'new'}`
    },
  },
  methods: {
    checkValueIsNumber,
    openImagePicker() {
      const input = document.getElementById(this.imageInputId)
      if (input) {
        input.click()
      }
    },
    onFileChange(e) {
      const file = e.target.files && e.target.files[0];
      if (!file) {
        return
      }
      this.item.image = file;
      this.item.featureImage = file;
      this.item.featureImagePreview = URL.createObjectURL(file);
      this.$forceUpdate()
    },
    removeAttributeImage() {
      if (!confirm('از حذف عکس اطمینان دارید؟')) {
        return
      }
      const clearLocal = () => {
        this.item.featureImagePreview = '';
        this.item.image = [];
        this.item.featureImage = null;
        const input = document.getElementById(this.imageInputId)
        if (input) {
          input.value = ''
        }
        this.$forceUpdate()
      }

      if (this.checkValueIsNumber(this.item.id)) {
        this.$store.dispatch('Feature/removeFeatureAttributeImage', this.item).then(() => {
          clearLocal()
        }).catch(() => {
          clearLocal()
        })
      } else {
        clearLocal()
      }
    },
    removeFeatureAttribute() {
      this.$emit('removeFeatureAttribute', this.featureIndex)
    },
    addVariable(value) {
      this.item.value += `f${value.feature_attributes[0].id}`
    }
  },
}
</script>

<style scoped>
.attr-row {
  display: grid;
  gap: 0.65rem;
}

.attr-row--with-image {
  grid-template-columns: minmax(0, 1fr) 88px;
  align-items: start;
}

.attr-row__main {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  min-width: 0;
}

.attr-row__check {
  width: 40px;
  height: 40px;
  margin: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  border: 1px solid rgba(30, 30, 30, 0.1);
  background: #f7f7f8;
  flex: 0 0 auto;
  cursor: pointer;
}

.attr-row__check input {
  width: 16px;
  height: 16px;
  margin: 0;
  cursor: pointer;
}

.attr-row__input {
  flex: 1 1 auto;
  min-width: 0;
}

.attr-row__input .form-control,
.attr-row__input >>> .form-control {
  height: 40px;
  border-radius: 12px !important;
  border-color: rgba(30, 30, 30, 0.12) !important;
}

.attr-row__formula-search {
  margin-top: 0.45rem;
}

.attr-row__close {
  width: 40px;
  height: 40px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 1px solid rgba(220, 37, 48, 0.18);
  border-radius: 12px;
  background: rgba(220, 37, 48, 0.08);
  color: #dc2530;
  flex: 0 0 auto;
  cursor: pointer;
}

.attr-row__close:hover {
  background: rgba(220, 37, 48, 0.16);
}

.attr-row__media {
  min-width: 0;
}

.attr-row__image-wrap {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.25rem;
  width: 88px;
  height: 88px;
  padding: 0.35rem;
  border-radius: 14px;
  background: #f5f5f6;
  border: 1.5px dashed rgba(30, 30, 30, 0.14);
  cursor: pointer;
  overflow: hidden;
  color: #6b6b6b;
}

.attr-row__image-wrap:hover {
  border-color: #eb3d60;
  color: #eb3d60;
  background: rgba(235, 61, 96, 0.04);
}

.attr-row__image-icon {
  font-size: 1.35rem;
}

.attr-row__image-text {
  font-size: 0.68rem;
  font-weight: 700;
  text-align: center;
  line-height: 1.2;
}

.attr-row__image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 10px;
}

.attr-row__image-remove {
  position: absolute;
  top: 4px;
  left: 4px;
  width: 26px;
  height: 26px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 0;
  border-radius: 8px;
  background: rgba(220, 37, 48, 0.92);
  color: #fff;
  cursor: pointer;
  z-index: 2;
}

.attr-row__image-remove:hover {
  background: #dc2530;
}

@media (max-width: 767.98px) {
  .attr-row--with-image {
    grid-template-columns: 1fr;
  }

  .attr-row__image-wrap {
    width: 100%;
    height: 110px;
  }
}
</style>
